/**
 * 自定义指令
 * **/

import Vue from 'vue';
import { getPDFCover } from './api';

// 监听 dom 懒加载 pdf 封面
const pdfCache = {};
const observer = new IntersectionObserver(function (changes) {
	changes.forEach(function (entries) {
		if (entries.intersectionRatio > 0) {
			const element = entries.target;
			const { src } = element.dataset;
			if (!pdfCache[src]) {
				getPDFCover(src).then(cover => {
					element.src = cover;
					pdfCache[src] = cover;
					observer.unobserve(element);
				});
			} else {
				element.src = pdfCache[src];
				observer.unobserve(element);
			}
		}
	});
});

Vue.directive('loadPDF', {
	bind(el) {
		observer.observe(el);
	},
	unbind(el) {
		observer.unobserve(el);
	}
});

/**
 * 数字动画指令
 * 1. 将绑定值转换为字符串并设置到 data-animate-number 属性
 * 2. 设置初始文本内容为 0
 */
Vue.directive('animateNumber', {
	bind(el, binding) {
		const value = binding.value != null ? String(binding.value) : '';
		el.setAttribute('data-animate-number', value);
		el.textContent = '0';
	},
	update(el, binding) {
		const value = binding.value != null ? String(binding.value) : '';
		el.setAttribute('data-animate-number', value);
		el.textContent = value;
	}
});

/**
 * Surf Loading 指令
 * 封装 Element UI loading，预设背景色和自定义类
 */
Vue.directive('surf-loading', {
	bind(el, binding, vnode) {
		el.setAttribute('element-loading-background', 'rgba(var(--surf-primary-color-rgb), 0.8)');
		el.setAttribute('element-loading-custom-class', 'surf-content-loading');
		const loadingDirective = Vue.options.directives['loading'];
		if (loadingDirective && loadingDirective.bind) {
			loadingDirective.bind(el, binding, vnode);
		}
	},
	update(el, binding, vnode) {
		el.setAttribute('element-loading-background', 'rgba(var(--surf-primary-color-rgb), 0.8)');
		el.setAttribute('element-loading-custom-class', 'surf-content-loading');
		const loadingDirective = Vue.options.directives['loading'];
		if (loadingDirective && loadingDirective.update) {
			loadingDirective.update(el, binding, vnode);
		}
	},
	unbind(el, binding, vnode) {
		const loadingDirective = Vue.options.directives['loading'];
		if (loadingDirective && loadingDirective.unbind) {
			loadingDirective.unbind(el, binding, vnode);
		}
	}
});
